import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Banco } from '../interfaces/banco';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class BancoService {

  readonly path = '/banco';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) { }


  create(): Observable<Banco> {
    return this.http.post<Banco>(`${this.jwtAuthService.apiUrl + this.path}`, null);
  }

  saveOrUpdate(banco: Banco): Observable<Banco> {
    return this.http.put<Banco>(`${this.jwtAuthService.apiUrl + this.path}`, banco);
  }

  getBanco(id: number ): Observable<Banco> {
    return this.http.get<Banco>(`${this.jwtAuthService.apiUrl + this.path}/?BancoId=${id}`);
  }

  getBancoPage(page?: number, size?: number): Observable<PageResult<Banco>> {
    return this.http.get<PageResult<Banco>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=${size}`);
  }

  getBancoPageSearch(page?: number, size?: number,  search?: string): Observable<PageResult<Banco>> {
    return this.http.get<PageResult<Banco>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=${size}&search=${search}`);
  }

  deleteBanco(id: number): Observable<any> {
    return this.http.delete<any>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

}
